module.exports = __webpack_public_path__ + "img/fondo.ca78fad0.png";